import getUserLocale from 'get-user-locale';
import ImperialUnitLocale from './ImperialUnitLocale';
import MetricUnitLocale from './MetricUnitLocale';

let userLocale = null;

/**
 * Initializes the user's locale.
 */
export default function init() {
  userLocale = getUnitLocale();
}

/**
 * Returns the determined user locale.
 *
 * @returns {String}
 */
export function getUserLocaleValue() {
  return userLocale;
}

/**
 * Returns the determined user locale.
 *
 * @returns {String}
 */
export function setUserLocaleValue(locale) {
  userLocale = locale;
}

/**
 * Converts the given value to the appropriate value based on the current locale.
 *
 * @param {Number} value
 * @param {String} fromUnit
 * @returns {Number}
 */
export function convertDistance(value, fromUnit) {
  return userLocale.convertDistance(value, fromUnit);
}

/**
 * Converts the given fuel economy to the appropriate value based on the current locale.
 *
 * @param {Number} economy
 * @param {String} fromUnit
 * @returns {Number}
 */
export function convertFuelEconomy(economy, fromUnit) {
  return Number(userLocale.convertFuelEconomy(economy, fromUnit));
}

/**
 * Converts the given velocity to the appropriate value based on the current locale.
 *
 * @param {Number} velocity
 * @param {String} fromUnit
 * @returns {Number}
 */
export function convertVelocity(velocity, fromUnit) {
  return userLocale.convertVelocity(velocity, fromUnit);
}

/**
 * Returns the appropriate unit of measurement based on the current locale.
 *
 * @param {Number} value
 * @returns {String}
 */
export function getDistanceUnits(value, long) {
  return userLocale.getDistanceUnits(value, long);
}

/**
 * Returns the appropriate unit for fuel economy based on the current locale.
 *
 * @returns {String}
 */
export function getFuelEconomyUnits() {
  return userLocale.FUEL_ECONOMY_UNITS;
}

/**
 * Returns the appropriate unit of measurement based on the current locale.
 *
 * @returns {String}
 */
export function getVelocityUnits() {
  return userLocale.VELOCITY_UNITS;
}

/**
 * Returns the UnitLocale associated with the current locale.
 *
 * @returns {import('./UnitLocale').default}
 */
export function getUnitLocale() {
  switch (getUserLocale()) {
    case 'en-US':
    case 'en-LR':
    case 'my-MM':
      return new ImperialUnitLocale();
    default:
      return new MetricUnitLocale();
  }
}
